export const HEADER_HEIGHT = 48;
export const MOBILE_WIDTH = 360;
